import { useTranslation } from 'react-i18next';
import { Code2, Lock, ShieldCheck } from 'lucide-react';

/**
 * Left brand panel of the split LoginPage layout. Pure presentation.
 * Per docs/design/auth.md § Surface 1 — Anatomy.
 */
export function LoginBrandPanel() {
  const { t } = useTranslation('auth');
  return (
    <div className="flex h-full flex-col justify-between">
      <div />

      <div className="max-w-lg space-y-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-amber-500/28 bg-amber-500/8 px-3 py-1 font-mono text-[10.5px] uppercase tracking-[0.1em] font-semibold text-amber-500">
          <span
            className="h-1.5 w-1.5 rounded-full bg-amber-500"
            style={{ animation: 'pulse 2.5s ease-in-out infinite' }}
          />
          {t('brand.eyebrow')}
        </span>

        <h2 className="text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl">
          {t('brand.headline1')}
          <br />
          <span
            className="bg-clip-text text-transparent"
            style={{
              backgroundImage: 'linear-gradient(135deg, #F5A623 0%, #FFD580 55%, #F5A623 100%)',
            }}
          >
            {t('brand.headline2')}
          </span>
        </h2>

        <p className="text-base leading-relaxed text-muted-foreground">{t('brand.body')}</p>

        <div className="grid grid-cols-3 gap-6 border-t border-border/60 pt-6">
          <div>
            <div className="font-mono text-2xl font-semibold tabular-nums tracking-tight text-amber-500">
              {t('brand.stats.operatorsValue')}
            </div>
            <div className="mt-1 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
              {t('brand.stats.operatorsLabel')}
            </div>
          </div>
          <div>
            <div className="font-mono text-2xl font-semibold tabular-nums tracking-tight text-amber-500">
              {t('brand.stats.ordersValue')}
            </div>
            <div className="mt-1 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
              {t('brand.stats.ordersLabel')}
            </div>
          </div>
          <div>
            <div className="font-mono text-2xl font-semibold tabular-nums tracking-tight text-amber-500">
              {t('brand.stats.uptimeValue')}
            </div>
            <div className="mt-1 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
              {t('brand.stats.uptimeLabel')}
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3 font-mono text-[10.5px] text-muted-foreground/70">
        <span className="inline-flex items-center gap-1.5">
          <ShieldCheck className="h-3 w-3" /> {t('brand.foot.soc2')}
        </span>
        <span className="text-muted-foreground/40">·</span>
        <span className="inline-flex items-center gap-1.5">
          <Lock className="h-3 w-3" /> {t('brand.foot.readOnlyKeys')}
        </span>
        <span className="text-muted-foreground/40">·</span>
        <span className="inline-flex items-center gap-1.5">
          <Code2 className="h-3 w-3" /> {t('brand.foot.auditable')}
        </span>
      </div>
    </div>
  );
}
